import React from "react";
import {Text} from "@mantine/core";
import {IconScissors} from "@tabler/icons-react";

import type {Solution} from "../solutions";
import {featuresCards} from "../features-cards";
import {generateRandomPastDates} from "../utils";

import {shades} from "@fig/libs/client/styles/js/colors";

const expenseDates = generateRandomPastDates(4);

export const hairCareProfessionals: Solution = {
  name: "Hair Care Professionals",
  description: "Be one cut above the rest, no worry lines here.",
  icon: IconScissors,
  hero: {
    head: (
      <span>
        A new way for stylists to{" "}
        <Text component="span" c={shades.blue[6]} inherit>
          plan for taxes and save for retirement
        </Text>
      </span>
    ),
    deck: "We automate your finances, so you can focus on your business.",
    primaryButton: {
      //onClick: "",
      text: "Join the Waitlist",
    },
    imageSrc: "/assets/www/solutions/hair-care-professionals/hero.png",
    //bullets: [],
    imageBullets: [
      {
        iconSrc: "/assets/www/home/chat.png",
        text: (
          <span>
            Chat with your{" "}
            <Text component="span" c={shades.blue[6]} inherit fw={500}>
              financial advisor
            </Text>
          </span>
        ),
      },
      {
        iconSrc: "/assets/www/home/piggy-bank.png",
        text: (
          <span>
            Contribute to your{" "}
            <Text component="span" c={shades.blue[6]} inherit fw={500}>
              retirement
            </Text>
          </span>
        ),
      },
      {
        iconSrc: "/assets/www/home/coins-percent.png",
        text: (
          <span>
            Save for your{" "}
            <Text component="span" c={shades.blue[6]} inherit fw={500}>
              taxes
            </Text>
          </span>
        ),
      },
    ],
  },
  savings: {
    head: (
      <span>
        Stay on track to{" "}
        <Text component="span" c={shades.blue[6]} inherit>
          s
          <span style={{position: "relative"}}>
            h
            <span style={{position: "absolute", left: "0px", top: "-6px", fontSize: "130%", color: shades.pink[5]}}>
              /
            </span>
          </span>
          ave
        </Text>
      </span>
    ),
    deck: "We automatically track your income and expenses to create a savings plan based on your goals.",
    imageSrc: "/assets/www/solutions/hair-care-professionals/savings.png",
    income: "7890.00",
    expenses: "2871.09",
    contribution: "500.00",
  },
  advisor: {
    head: (
      <span>
        You're not alone. Dedicated advisors help you{" "}
        <Text component="span" c={shades.blue[6]} inherit>
          achieve your goals
        </Text>
        .
      </span>
    ),
    deck: "Comprehensive financial planning with direct access to registered advisors, on your schedule.",
    imageSrc: "/assets/www/solutions/hair-care-professionals/chat.png",
    chat: {
      messages: ["How much should I be saving for retirement?", "Have I set enough money aside for taxes this year?"],
      advisor: {
        name: "Kelly M.",
        title: "Her advisor",
        avatarSrc: "/assets/www/home/advisor.png",
      },
      button: {
        //onClick: "",
        text: "Join the Waitlist",
      },
    },
  },
  expenses: {
    head: "Receipts are a pain",
    deck: (
      <span>
        <br />
        You've got enough going on.
        <br />
        <br /> Let Fig keep tabs of your spending and deductions.
      </span>
    ),
    imageSrc: "/assets/www/solutions/hair-care-professionals/expenses.png",
    transactions: [
      {
        brandImageSrc: "/assets/www/solutions/hair-care-professionals/brands/wahl.png",
        brandName: "Wahl",
        price: "129.31",
        date: expenseDates[0],
        category: "Supplies",
      },
      {
        brandImageSrc: "/assets/www/solutions/hair-care-professionals/brands/uber.png",
        brandName: "Uber",
        price: "41.24",
        date: expenseDates[1],
        category: "Transportation",
      },
      {
        brandImageSrc: "/assets/www/solutions/hair-care-professionals/brands/ichiro.png",
        brandName: "Ichiro",
        price: "249.00",
        date: expenseDates[2],
        category: "Supplies",
      },
      {
        brandImageSrc: "/assets/www/solutions/hair-care-professionals/brands/rco.png",
        brandName: "R+Co",
        price: "225.02",
        date: expenseDates[3],
        category: "Supplies",
      },
    ],
  },
  features: {
    head: "You're covered on all fronts",
    deck: "Choose one service, choose them all. It's totally up to you.",
    cards: featuresCards,
  },
  callToAction: {
    head: "Take the guesswork out of financial planning",
    //deck: "",
    primaryButton: {
      //onClick: "",
      text: "Join the Waitlist",
    },
  },
};
